import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { FUTURE_LIVE_CARD_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, FUTURE_LIVE_CARD_TRANSLATION_KEY, {
  SEE_DETAILS: 'Ver detalhes',
  SUBSCRIBE: 'Inscreva-se',
  ALREADY_SUBSCRIBED: 'Está inscrito',
  GO_TO_LIVE: '¡Ir para o live!'
});